import { Action } from 'common/enums';
import { GridApi } from 'ag-grid-community/dist/lib/gridApi';
import { Dispatch, SetStateAction } from 'react';
import { AccessActions, FeatureActions } from '../enums/admin-role.enum';

export const ADMIN_ROLES_MANAGEMENT_TITLE = 'Roles';
export const ROLE_NAME_EMPTY_ERROR = 'Role Name cannot be empty';
export const ROLE_NAME_MAX_LENGTH = 100;
export const ROLE_NAME_MAX_LENGTH_ERROR = `Role Name exceeds ${ROLE_NAME_MAX_LENGTH} characters!`;
export const ROLE_NAME_INVALID_CHAR_ERROR = 'Role Name has invalid characters';
export const DESCRIPTION_MAX_LENGTH = 1000;
export const DESCRIPTION_MAX_LENGTH_ERROR = 'Description text exceeds 1000 characters!';
export const DESCRIPTION_INVALID_CHAR_ERROR = 'Description has invalid characters';
export const UNCHECK_ERROR = 'Can not uncheck Read Access when Write Access is checked';
export const getAdminRolesManagementData = (
    onAction: (action: Action, data: any, gridApi: GridApi) => void,
    isAdminRoleActionAccessDisabled = false,
    minWidth = 50
) => [
    {
        field: 'applicationRoleName',
        headerName: 'Name',
        minWidth: minWidth,
        width: 200,
        resizable: true,
        cellRenderer: 'LabelCellRenderer',
        cellRendererParams: {
            className: 'ellipsis'
        }
    },
    {
        field: 'description',
        headerName: 'Description',
        minWidth: minWidth,
        width: 350,
        resizable: true,
        cellRenderer: 'LabelCellRenderer',
        cellRendererParams: {
            className: 'ellipsis'
        }
    },
    {
        field: '',
        headerName: 'Action',
        minWidth: 150,
        resizable: true,
        cellRenderer: 'whatsNewActionCellRenderer',
        cellRendererParams: {
            onAction: onAction,
            isSetUpDisabled: isAdminRoleActionAccessDisabled
        }
    }
];

export const getFeatureListColDefs = (
    onAction: (isChecked: boolean, data: any, gridApi: GridApi, actionName: string) => void,
    minWidth = 100
) => [
    {
        field: 'featureName',
        headerName: 'Name',
        cellRenderer: 'LabelCellRenderer',
        minWidth: minWidth
    },
    {
        field: 'readAccess',
        headerName: 'Read',
        minWidth: 50,
        resizable: true,
        cellRenderer: 'CheckboxCellRendererGeneric',
        cellRendererParams: {
            onAction: onAction,
            //value: data.readAccess,
            actionName: 'Read'
        }
    },
    {
        field: 'writeAccess',
        headerName: 'Write',
        minWidth: 50,
        resizable: true,
        cellRenderer: 'CheckboxCellRendererGeneric',
        cellRendererParams: {
            onAction: onAction,
            //value: isChecked,
            actionName: 'Write'
        }
    }
];

export const getFeaturesHeaders = (
    onAction: (
        value: boolean,
        data: any,
        action: FeatureActions,
        api: GridApi,
        rowIndex: number,
        actionName: AccessActions
    ) => void,
    isAdminRoleActionAccessDisabled: boolean
) => [
    {
        field: 'featureName',
        headerName: 'Feature Name',
        width: 250,
        cellRenderer: 'FeaturesHierarchyCellRenderer',
        cellRendererParams: {
            onAction: onAction,
            className: 'ellipsis'
        },
        cellClass: 'name-cell-custom'
    },
    {
        field: 'readAccess',
        headerName: 'Read Access',
        width: 75,
        cellRenderer: 'FeaturesCheckbox',
        cellRendererParams: {
            onAction: onAction,
            actionName: AccessActions.READ,
            isAdminRoleActionAccessDisabled
        }
    },
    {
        field: 'writeAccess',
        headerName: 'Write Access',
        width: 75,
        cellRenderer: 'FeaturesCheckbox',
        cellRendererParams: {
            onAction: onAction,
            actionName: AccessActions.WRITE,
            isAdminRoleActionAccessDisabled
        }
    }
];
